import React from 'react';

import uuid from 'uuid';

import { StyledCampaignRange } from './style/StyledCampaignRange';

import NotFound from '../NotFound';

import DynamicComponent from '../../DynamicComponent';

const CampaignRange = ({ data, channel, isLast }) => (
	<StyledCampaignRange channel={channel}>
		<section>
			<h2>{data.title} </h2>
			<p>{data.content.text}</p>
		</section>

		{
			(data.charts.length > 0) ? (
				<div className="content-1200">
					<div className="content-charts">
						{data.charts.map(chart => <DynamicComponent tag={chart.type} data={chart.data} typeChart="CampaignRange" channel={channel} key={uuid.v4()} />)}
					</div>

					<div className="legend">
						<div className="topic-1">
							Cliques
						</div>
						<div className="topic-2">
							Impressões
						</div>
					</div>
				</div>
			) : (
				<section className="mt-4">
					<NotFound />
				</section>
				)
		}

		{!isLast ? <hr className="mt-4" /> : null}
	</StyledCampaignRange>
);

export default CampaignRange;
